import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';

const CrewStatus = ({ formState }) => {
  const { fields, changeField } = useFormState(formState);

  return (
    <div>
      <Row className="no-gutters">
        <Col>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>

      <Row className="no-gutter">
        <Col>
          <Input label="Label" onChange={changeField('label')} {...fields.label} />
        </Col>
      </Row>
    </div>
  );
};

export default CrewStatus;
